import { ApiBuilderType } from 'modules/common/types'
import { NotificationTemplateType } from './getTemplate'

export const upsertTemplate = (builder: ApiBuilderType) =>
	builder.mutation<void, NotificationTemplateType>({
		query: data => {
			return {
				url: '/notification-templates',
				method: 'POST',
				body: data,
			}
		},
	})
